module.exports = __webpack_public_path__ + "static/media/shingan_doc_flow.2e57e4f3.png";